import type { TextureScrollDef } from '@viewer/world/worldTypes';

const DEFAULT_STEP_FPS = 12;

function finiteOrZero(value: number | undefined): number {
  return typeof value === 'number' && Number.isFinite(value) ? value : 0;
}

export function hasTextureScroll(
  scroll: TextureScrollDef | undefined | null,
): scroll is TextureScrollDef {
  if (!scroll) return false;
  return finiteOrZero(scroll.u) !== 0 || finiteOrZero(scroll.v) !== 0;
}

export function textureScrollOffset(
  scroll: TextureScrollDef,
  elapsedSeconds: number,
): { u: number; v: number } {
  const safeElapsed = Math.max(0, Number.isFinite(elapsedSeconds) ? elapsedSeconds : 0);
  const fps = finiteOrZero(scroll.fps) > 0 ? finiteOrZero(scroll.fps) : DEFAULT_STEP_FPS;
  const t = scroll.mode === 'step' ? Math.floor(safeElapsed * fps) / fps : safeElapsed;

  return {
    u: finiteOrZero(scroll.u) * t,
    v: finiteOrZero(scroll.v) * t,
  };
}

export function wrapTextureOffset(value: number): number {
  if (!Number.isFinite(value)) return 0;
  return ((value % 1) + 1) % 1;
}
